// docs: https://github.com/altostra/type-validations#readme
import { objectOf, recordOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isAppGroupSessionLifetimeStatsResults = objectOf({
  lifetime_users: number,
  lifetime_users_by_app: recordOf({
    key: string,
    value: number,
  }),
  lifetime_sessions: number,
  lifetime_sessions_by_app: recordOf({
    key: string,
    value: number,
  }),
  current_mau: number,
});
